import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LoginForm } from './components/auth/LoginForm';
import { RegisterForm } from './components/auth/RegisterForm';
import { AuthGuard } from './components/auth/AuthGuard';
import { BuildingView } from './components/BuildingView';
import { Dashboard } from './components/dashboard/Dashboard';
import { ProfilePage } from './components/profile/ProfilePage';
import { ConnectionStatusBar } from './components/ConnectionStatusBar';
import { OfflineStatusBar } from './components/OfflineStatusBar';
import { CalendarView } from './components/CalendarView';

function App() {
  return (
    <Router>
      {/* Status bars container with padding to prevent content overlap */}
      <div className="relative">
        <div className="fixed top-0 left-0 right-0 z-50">
          <ConnectionStatusBar />
          <OfflineStatusBar />
        </div>
        {/* Add padding to main content to prevent overlap with status bars */}
        <div className="pt-[40px]">
          <Routes>
            <Route path="/login" element={<LoginForm />} />
            <Route path="/register" element={<RegisterForm />} />
            <Route path="/profile" element={
              <AuthGuard>
                <ProfilePage />
              </AuthGuard>
            } />
            <Route path="/calendar" element={
              <AuthGuard>
                <CalendarView />
              </AuthGuard>
            } />
            <Route path="/dashboard" element={
              <AuthGuard>
                <Dashboard />
              </AuthGuard>
            } />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route
              path="/building/:id"
              element={
                <AuthGuard>
                  <div className="min-h-screen bg-gray-100 p-8">
                    <BuildingView />
                  </div>
                </AuthGuard>
              }
            />
            <Route
              path="/building/new"
              element={
                <AuthGuard>
                  <div className="min-h-screen bg-gray-100 p-8">
                    <BuildingView />
                  </div>
                </AuthGuard>
              }
            />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;